import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { LifeBuoy, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SupportWidget() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(user?.email || "");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) { toast.error("Napíšte prosím popis problému"); return; }
    setBusy(true);
    try {
      await api.post("/support/tickets", { email: email || user?.email, message, page_url: window.location.pathname });
      toast.success("Ďakujeme! Vaša správa bola odoslaná.");
      setMessage(""); setOpen(false);
    } catch (e2) { toast.error(e2?.response?.data?.detail || "Nepodarilo sa odoslať správu"); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button
        variant="ghost"
        className="mt-1 w-full justify-start gap-3 text-muted-foreground hover:text-foreground"
        onClick={() => setOpen(true)}
        data-testid="support-fab"
      >
        <LifeBuoy className="h-5 w-5 shrink-0" /> Nahlásiť problém
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="support-dialog">
          <DialogHeader><DialogTitle>Nahlásiť problém alebo chybu</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-muted-foreground">Narazili ste na chybu alebo máte návrh? Napíšte nám a ozveme sa na váš e-mail.</p>
            <div className="space-y-1.5">
              <Label htmlFor="support-email">Váš e-mail</Label>
              <Input id="support-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vas@email.sk" data-testid="support-email" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="support-message">Popis problému</Label>
              <Textarea id="support-message" required rows={5} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Opíšte, čo sa stalo alebo čo potrebujete…" data-testid="support-message" />
            </div>
            <DialogFooter>
              <Button type="button" variant="ghost" onClick={() => setOpen(false)} data-testid="support-cancel">Zrušiť</Button>
              <Button type="submit" disabled={busy} data-testid="support-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Odoslať"}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
